/* eslint-disable react-refresh/only-export-components */
import React from 'react';
import { Input as AntInput, InputProps as AntInputProps, InputRef } from 'antd';
import styles from './Input.module.scss';

export interface InputProps extends AntInputProps {
  className?: string;
}

export const Input = React.forwardRef<InputRef, InputProps>(
  ({ className, children, ...props }, ref) => (
    <AntInput
      ref={ref}
      className={[styles.input, className].filter(Boolean).join(' ')}
      {...props}
    >
      {children}
    </AntInput>
  )
);
